import React, { useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import { Link } from 'react-router-dom';
import TeamsTable from './TeamsTable'; // Import TeamsTable component

const Search = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/api/user/search`, {
        params: { input: searchTerm },
      });

      if (!response.data) {
        console.error("No data in API response");
        return;
      }

      setUsers(response.data.users || []);
      setTeams(response.data.teams || []);
    } catch (error) {
      console.error("Error performing search", error);
      setUsers([]);
      setTeams([]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div>
      <input 
        type="text" 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)} 
        onKeyDown={handleKeyPress} 
        placeholder="Search by name or email" 
      />
      <button onClick={handleSearch}>Search</button>

      {loading ? (
        <div style={{ margin: "20px", textAlign: "center" }}>
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <>
          {/* Teams List (Using TeamsTable) */}
          <div>
            <h3>Teams</h3>
            <TeamsTable teams={teams} />
          </div>

          {/* Users List */}
          <div>
            <h3>Users</h3>
            {users.length > 0 ? (
              <ul>
                {users.map(user => (
                  <li key={user.id}>
                    <Link to={`/user/${user.id}`}>{user.email}</Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No users found</p>
            )}
          </div>
        </>
      )}

      {/* Simple CSS spinner */}
      <style>{`
        .spinner {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          animation: spin 1s linear infinite;
          margin: 0 auto;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Search;
